import { ECountry, ELanguage } from '@portals/help-center-core';
import { PRO_WB_CN, PRO_WB_RU } from '@/layouts/app-layout/_constants';

type TProps = {
  locale: ELanguage;
  country: ECountry;
};

export const getNavBarItems = ({ locale, country }: TProps) => [
  {
    id: 'learnInfo',
    text: 'menuItemEducation',
    // тут сами переключаем, потому что в pro.wildberries.ru в исключениях в geo-utils
    routeName: `${
      country === ('cn' as ECountry) ? PRO_WB_CN : PRO_WB_RU
    }/${locale}/events-calendar`,
  },
];
